import React, { PureComponent } from 'react';

class UnionMemberField extends PureComponent {
    render() {
        const { unionMember, setUnionMember } = this.props;

        return (
            <div className="fieldwrap ">
                <label htmlFor="unionMember">
                    Are you a member of a trade union?
                </label>
                <div className="row">
                    <div className="col-sm-auto">
                        <label
                            onClick={e => setUnionMember('yes')}
                            className={
                                unionMember == 'yes' ? 'radio __active' : 'radio'
                            }
                        >
                        <input type="radio" name="unionMember" /> Yes
                        </label>
                    </div>
                    <div className="col-sm-auto">
                        <label
                            onClick={e => setUnionMember('no')}
                            className={
                                unionMember == 'no' ? 'radio __active' : 'radio'
                            }
                        >
                        <input type="radio" name="unionMember" /> No
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}

export default UnionMemberField;



// WEBPACK FOOTER //
// ./src/Form/UnionMemberField.js